/**
 * Linear interpolation from height (m MSL) to pressure (hPa) using the env data.
 * Returns NaN if the altitude is outside the data range.
 * Assumes data is sorted by descending pressure (surface first, top last).
 */
export function altitudeToPressure(altM, data) {
    for (let i = 0; i < data.length - 1; i++) {
        const a = data[i];
        const b = data[i + 1];
        if (altM >= a.hght && altM <= b.hght) {
            const f = (altM - a.hght) / (b.hght - a.hght);
            return a.press + f * (b.press - a.press);
        }
    }
    return NaN;
}
